import { categories } from '@/mocks/categories';

const iconBgColors = [
  'bg-accent-50',
  'bg-secondary-50',
  'bg-primary-50',
  'bg-accent-100',
  'bg-secondary-100',
  'bg-primary-100',
  'bg-accent-50',
  'bg-secondary-50',
  'bg-primary-50',
  'bg-accent-100',
  'bg-secondary-100',
  'bg-primary-100',
  'bg-accent-50',
  'bg-secondary-50',
];

const iconColors = [
  'text-accent-600',
  'text-secondary-600',
  'text-primary-600',
  'text-accent-700',
  'text-secondary-700',
  'text-primary-700',
  'text-accent-600',
  'text-secondary-600',
  'text-primary-600',
  'text-accent-700',
  'text-secondary-700',
  'text-primary-700',
  'text-accent-600',
  'text-secondary-600',
];

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-5 py-1.5 rounded-full border border-foreground-200/60 text-foreground-500 text-xs font-label font-medium tracking-wide uppercase">
            Категории
          </span>
          <h2 className="mt-5 text-3xl md:text-[42px] font-heading font-bold text-foreground-950 leading-tight">
            Вся мода из Китая
            <br />
            <span className="italic font-medium text-foreground-700">В одной таблице</span>
          </h2>
          <p className="mt-3 text-base text-foreground-400 font-light">
            Выберите категорию и начните шоппинг прямо сейчас
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col gap-3 p-5 md:p-6 rounded-2xl bg-white border border-foreground-100/60 hover:bg-accent-50/60 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBgColors[idx]}`}>
                <i className={`${cat.icon} ${iconColors[idx]} text-xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 leading-tight">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 font-light leading-relaxed">
                Лучшие {cat.name.toLowerCase()} из Китая — выгодные цены и быстрая доставка
              </p>
              <span className="mt-auto inline-flex items-center gap-2 h-9 px-4 rounded-full bg-white border border-foreground-200/50 text-foreground-500 text-xs font-medium group-hover:bg-accent-50 group-hover:border-accent-300 group-hover:text-accent-700 transition-all duration-300 whitespace-nowrap self-start cursor-pointer">
                Смотреть
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}